





































import Vue from 'vue'

export default Vue.extend({
  name: 'TimePicker.vue',
  props: {
    title: String,
    pastNotification: Boolean
  },
  data () {
    return {
      menuOpened: false,
      time: null
    }
  },
  methods: {
    closePicker (v: string | number) {
      v = v < 10 ? '0' + v : v
      this.time = v + ':00'
      this.menu = false
      this.$refs.menu.save(this.time)
    }
  },
  watch: {
    time (val) {
      this.$emit('timeChanged', val)
    }
  }
})
